import { __awaiter } from "tslib";
import { useAdsCore } from '@slickdeals/ads-core';
import { initWebInstrumentation } from '../utilities/initWebInstrumentation';
export const initPage = () => __awaiter(void 0, void 0, void 0, function* () {
    useAdsCore().initAdStack();
    initWebInstrumentation();
});
